import { put, takeLatest } from 'redux-saga/effects';
import cognitiveSkillsActionTypes from '../types';
import {
  fetchStudentCognitiveAssessmentSuccess,
  fetchStudentCognitiveAssessmentFailure,
} from '../actions';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';

export function* fetchStudentCognitiveAssessment({ payload }) {
  try {
    const response = yield httpClient.get(`/cognitive-skill-assessment`, { params: payload });
    yield put(fetchStudentCognitiveAssessmentSuccess(response.data));
  } catch (error) {
    yield put(fetchStudentCognitiveAssessmentFailure(error?.message));
    const err = handleError(error);
  }
}

export function* onfetchStudentCognitiveAssessmentStart() {
  yield takeLatest(
    cognitiveSkillsActionTypes.FETCH_STUDENT_COGNITIVE_ASSESSMENT_START,
    fetchStudentCognitiveAssessment,
  );
}
